/**
 * Main Entry Point - EduQ AI Admin Portal
 * 
 * Initializes Amplify and renders the React application
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureAmplify } from './config/amplify-config.js';
import { App } from './App.jsx';

// Import styles
import './styles/design-tokens.css';
import './styles/admin.css';
import './styles/layout.css';

// Import page styles
import './pages/ViewAsUser.css';
import './pages/ContentManagement.css';

// Initialize Amplify and render app
const initializeApp = async () => {
  try {
    // Configure Amplify
    await configureAmplify();
    
    // Render React app
    ReactDOM.createRoot(document.getElementById('root')).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('[Main] Failed to initialize app:', error);
    
    // Render error state
    ReactDOM.createRoot(document.getElementById('root')).render(
      <div style={{ padding: '2rem', fontFamily: 'sans-serif', color: '#EF4444' }}>
        <h1>Configuration Error</h1>
        <p>Failed to initialize admin portal. Please check the console for details.</p>
        <pre style={{ background: '#F3F4F6', padding: '1rem', borderRadius: '0.5rem', overflow: 'auto' }}>
          {error.message}
        </pre>
      </div>
    );
  }
};

// Start the app
initializeApp();
